import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactGA from "react-ga";

import { Container, Row, Col } from "react-grid-system";
import { motion } from "framer-motion";
import { Field } from "react-final-form";
import Summary from "../components/Summary";
import Fade from "../animate/Fade";

const Estimate = ({ price, error, loading }) => {
  useEffect(() => {
    ReactGA.event({
      category: "Move Calculator",
      action: "Step",
      label: "Estimate",
    });
  }, []);
  return error ? null : (
    <motion.div layout>
      <Container className="form-fields row">
        <Row>
          <h3>{loading ? "Calculating..." : "Here's Your Estimate"}</h3>
          <Col sm={12}>
            <Summary />
          </Col>
          <Col sm={12} className="spacing">
            <Fade show={!!price}>
              <h4>Next step:</h4>
              <label className="radio" htmlFor="estimateActions-book">
                <Field
                  id="estimateActions-book"
                  name="estimateActions"
                  component="input"
                  type="radio"
                  value="book"
                />{" "}
                Book my move now
              </label>
              <label className="radio" htmlFor="estimateActions-contact">
                <Field
                  id="estimateActions-contact"
                  name="estimateActions"
                  component="input"
                  type="radio"
                  value="contact"
                />{" "}
                I really want to talk with someone
              </label>
            </Fade>
          </Col>
        </Row>
      </Container>
    </motion.div>
  );
};

Estimate.propTypes = {
  price: PropTypes.number,
  error: PropTypes.instanceOf(Error),
  loading: PropTypes.bool,
};

Estimate.defaultProps = {
  price: 0,
  error: null,
  loading: true,
};

const mapStateToProps = (state) => ({
  price: state.estimate.estimate,
  error: state.estimate.error,
  loading: state.estimate.loading,
});

export default connect(mapStateToProps)(Estimate);
